module.exports = __webpack_public_path__ + "static/img/cnc3.b44e9f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/cnc3.jpg
// module id = 0cR6
// module chunks = 2